<template>
  <div>
    <div class="main">
      <div class="form-row">
        <div class="form-field">
          <label for="reg-fio-input">Телефон:</label>
          <input id="reg-fio-input" v-model="phone" type="text" />
        </div>
        <div class="form-field">
          <button @click="send">
            Отправить пароль
          </button>
        </div>
      </div>
      <div class="form-row" v-if="info">{{ info }}</div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import config from "@/config";

export default {
  name: "forgot-password",
  data() {
    return {
      url: config.backend_url,
      info: null,
      phone: null
    };
  },
  computed: {
    auth: function() {
      return this.$store.getters["auth/isAuthenticated"];
    }
  },
  methods: {
    send: function() {
      const { phone } = this;
      axios
        .post(this.url + "users/forgot-password", {
          data: { phone: phone }
        })
        .then(response => {
          let data = response.data;
          if (data.status === "OK") {
            alert("Временный пароль отправлен на ваш телефон");
            this.goToLogin();
          }
        });
    },
    goToLogin: function() {
      this.$router.push("/login");
    },
    goToHome: function() {
      this.$router.push("/");
    }
  },
  mounted() {
    if (this.auth) {
      this.goToHome();
    }
  }
};
</script>
